module.exports = __webpack_public_path__ + "static/media/20201121_214739_761_IMG_0956.52f93b67.jpg";